module.exports = __webpack_public_path__ + "static/media/knife.47152a6e.svg";